var HAIER_YR_HD06 = {
  name: "HAIER YR HD06",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [229,0,5,95,2,220,1,61,12,184,11,65,12,33,17,99,2,61,6,108,2,0,0,72,199,17,248,143,227,255,248,227,199,252,68,71,143,248,136,143,255,255,255,227,24,226,49,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,53,12,189,11,81,2,86,6,52,12,34,17,77,2,225,1,100,2,0,0,148,81,21,17,17,21,17,17,17,21,68,68,68,68,69,69,81,69,17,17,17,17,85,17,20,68,68,68,69,84,68,68,68,68,68,68,68,68,68,68,68,68,68,68,69,20,69,20,68,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,82,2,87,6,52,12,184,11,56,12,29,17,77,2,222,1,104,2,0,0,76,98,56,136,143,17,17,17,30,34,34,34,34,56,241,140,68,68,68,71,196,70,34,34,34,35,226,34,34,34,34,34,34,34,34,34,34,34,34,34,34,49,136,241,17,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,94,2,62,6,54,12,194,11,45,12,29,17,93,2,218,1,101,2,0,0,76,98,56,136,199,17,17,17,30,34,34,34,34,56,241,140,68,68,68,71,196,70,34,34,34,35,226,34,34,34,34,34,34,34,34,34,34,34,34,34,34,49,140,70,34,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,93,2,63,6,61,12,189,11,51,12,26,17,88,2,220,1,102,2,0,0,76,98,56,136,248,136,136,136,241,17,17,17,17,199,140,98,34,34,34,62,34,49,17,17,17,31,17,17,17,17,17,17,17,17,17,17,17,17,17,17,17,140,99,136,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,96,2,66,6,56,12,184,11,56,12,22,17,78,2,221,1,104,2,0,0,76,98,56,140,71,17,17,17,30,34,34,34,34,56,241,140,68,68,68,71,196,70,34,34,34,35,226,34,34,34,34,34,34,34,34,34,34,34,34,34,34,49,142,49,17,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,81,2,80,6,49,12,185,11,56,12,28,17,77,2,223,1,96,2,0,0,76,98,56,140,120,136,136,136,241,17,17,17,17,199,140,98,34,34,34,62,34,49,17,17,17,31,17,17,17,17,17,17,17,17,17,17,17,17,17,17,17,140,124,68,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,85,2,72,6,50,12,192,11,50,12,31,17,79,2,220,1,133,2,0,0,76,98,56,142,56,136,136,136,241,17,17,17,17,199,140,98,34,34,34,62,34,49,17,17,17,31,17,17,17,17,17,17,17,17,17,17,17,17,17,17,17,142,34,49,17,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,87,2,69,6,50,12,186,11,55,12,27,17,85,2,215,1,103,2,0,0,76,98,56,143,196,68,68,71,136,136,136,136,142,60,99,17,17,17,17,241,17,136,136,136,136,248,136,136,136,136,136,136,136,136,136,136,136,136,136,136,140,113,28,68,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,87,2,80,6,59,12,188,11,51,12,27,17,76,2,221,1,107,2,0,0,76,98,56,196,71,17,17,17,30,34,34,34,34,56,241,140,68,68,68,71,196,70,34,34,34,35,226,34,34,34,34,34,34,34,34,34,34,34,34,34,34,49,198,49,17,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,90,2,71,6,61,12,193,11,48,12,22,17,84,2,216,1,98,2,0,0,76,98,56,196,120,136,136,136,241,17,17,17,17,199,140,98,34,34,34,62,34,49,17,17,17,31,17,17,17,17,17,17,17,17,17,17,17,17,17,17,17,142,60,68,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,79,2,65,6,58,12,194,11,45,12,31,17,85,2,223,1,91,2,0,0,76,98,56,198,56,136,136,136,241,17,17,17,17,226,34,49,136,136,136,136,248,136,196,68,68,68,124,68,68,68,68,68,68,68,68,68,68,68,68,68,68,70,60,70,49,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,88,2,78,6,82,12,159,11,83,12,25,17,77,2,223,1,95,2,0,0,76,98,56,199,196,68,68,71,136,136,136,136,143,17,17,140,68,68,68,71,196,70,34,34,34,35,226,34,34,34,34,34,34,34,34,34,34,34,34,34,34,49,227,140,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,59,12,173,11,98,2,218,1,78,12,29,17,99,2,31,6,105,2,0,0,145,69,68,81,21,17,85,81,85,85,85,20,84,68,81,85,85,17,17,84,85,85,68,68,85,85,85,85,85,85,85,84,81,17,81,17,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,80,2,76,6,55,12,190,11,52,12,32,17,78,2,222,1,102,2,0,0,76,98,56,227,196,68,68,71,136,136,136,136,143,17,17,140,68,68,68,71,196,70,34,34,34,35,226,34,34,34,34,34,34,34,34,34,34,34,34,34,34,49,252,98,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,87,2,85,6,52,12,195,11,46,12,27,17,77,2,220,1,97,2,0,0,76,98,56,241,196,68,68,71,136,136,136,136,143,17,17,140,68,68,68,71,196,70,34,34,34,35,226,34,34,34,34,34,34,34,34,34,34,34,34,34,34,49,136,136,198,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [229,0,5,52,12,185,11,57,12,30,17,80,2,73,6,78,2,223,1,96,2,0,0,164,72,137,34,34,34,72,136,136,136,146,68,68,68,68,68,146,34,34,36,136,136,136,136,146,72,136,145,17,17,17,18,73,17,17,17,17,17,17,17,17,17,17,17,17,17,17,17,34,73,34,68,136,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [229,0,5,67,12,186,11,56,12,0,17,97,2,67,6,87,2,217,1,78,2,0,0,164,72,137,34,34,36,145,17,17,17,36,136,136,136,136,137,36,68,72,146,34,34,34,34,73,34,34,68,68,68,68,73,36,68,68,68,68,68,68,68,68,68,68,68,68,68,68,68,137,36,146,36,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [229,0,5,55,12,195,11,88,2,77,6,46,12,22,17,78,2,217,1,77,2,0,0,148,81,21,17,20,84,68,68,68,85,17,17,17,17,21,68,69,21,17,17,17,17,85,17,20,68,68,68,69,84,68,68,68,68,68,68,68,68,68,68,68,68,68,68,69,20,68,69,21,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [229,0,5,60,12,193,11,86,2,77,6,78,2,198,1,49,12,28,17,93,2,0,0,138,82,84,146,170,73,36,149,73,36,146,74,164,148,169,36,146,74,169,37,36,146,73,85,36,146,73,36,146,73,36,146,73,36,146,82,146,84,168,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [229,0,5,54,12,190,11,87,2,219,1,88,2,68,6,52,12,29,17,90,2,0,0,137,74,146,165,73,85,84,146,170,170,146,85,41,42,170,164,146,169,85,85,36,149,85,85,85,85,85,85,85,41,82,148,144,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [229,0,5,93,2,218,1,56,12,190,11,95,2,59,6,53,12,27,17,106,2,0,0,68,206,78,100,159,228,159,249,39,153,63,228,147,207,249,36,255,255,255,254,103,36,201,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [229,0,5,78,2,219,1,86,2,73,6,52,12,162,11,80,12,26,17,78,2,0,0,34,221,117,175,245,127,234,246,191,234,189,255,85,255,255,255,253,183,106,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [229,0,5,88,2,217,1,89,2,42,6,63,12,188,11,54,12,22,17,78,2,0,0,34,221,117,87,250,191,245,123,95,245,94,255,170,255,255,255,254,219,90,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [229,0,5,77,2,223,1,81,12,188,11,87,2,83,6,55,12,25,17,78,2,0,0,68,206,76,242,127,146,127,228,158,100,255,146,79,63,228,147,255,255,255,249,153,51,36,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [229,0,5,77,2,213,1,83,2,80,6,56,12,188,11,54,12,31,17,88,2,0,0,34,221,110,175,245,127,234,246,191,234,189,255,85,255,255,255,253,181,90,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [229,0,5,77,2,223,1,54,12,180,11,87,2,83,6,61,12,24,17,78,2,0,0,68,206,76,204,159,228,159,249,39,153,63,228,147,207,249,36,255,255,255,254,100,243,36,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [229,0,5,77,2,221,1,78,2,89,6,86,12,184,11,60,12,32,17,77,2,0,0,34,221,109,87,250,191,245,123,95,245,94,255,170,255,255,255,254,215,90,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [229,0,5,82,2,217,1,89,2,72,6,79,12,188,11,55,12,27,17,95,2,0,0,34,221,107,175,245,127,234,246,191,234,189,255,85,255,255,255,253,173,181,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [229,0,5,80,2,223,1,87,2,73,6,64,12,186,11,57,12,23,17,86,2,0,0,34,221,107,87,250,191,245,123,95,245,94,255,170,255,255,255,254,214,173,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [229,0,5,77,2,223,1,82,2,82,6,60,12,192,11,50,12,29,17,92,2,0,0,34,221,106,215,250,191,245,123,95,245,94,255,170,255,255,255,254,213,218,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [229,0,5,82,2,222,1,81,2,88,6,51,12,187,11,56,12,27,17,93,2,0,0,34,221,126,191,213,255,171,187,255,85,239,250,175,255,255,255,237,93,112,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [229,0,5,86,2,220,1,81,2,71,6,57,12,191,11,53,12,38,17,103,2,0,0,34,221,125,95,234,255,213,221,255,170,247,253,87,255,255,255,246,173,92,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [229,0,5,77,2,223,1,89,2,80,6,61,12,185,11,58,12,26,17,94,2,0,0,34,221,123,95,234,255,213,221,255,170,247,253,87,255,255,255,246,171,92,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [229,0,5,79,2,209,1,88,2,69,6,81,12,189,11,55,12,28,17,96,2,0,0,34,221,122,175,245,127,234,235,127,234,189,255,85,255,255,255,253,170,171,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [229,0,5,78,2,223,1,76,12,187,11,95,2,80,6,55,12,14,17,80,2,0,0,68,206,78,114,127,146,127,228,156,153,255,146,79,63,228,147,255,255,255,249,159,38,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [229,0,5,85,2,223,1,88,2,72,6,85,12,167,11,78,12,33,17,77,2,0,0,34,221,118,175,245,127,234,235,127,234,189,255,85,255,255,255,253,189,90,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [229,0,5,79,2,225,1,86,2,76,6,61,12,189,11,54,12,27,17,99,2,0,0,34,221,117,175,245,127,234,235,127,234,189,255,85,255,255,255,253,187,90,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [229,0,5,77,2,223,1,83,2,82,6,55,12,185,11,59,12,32,17,86,2,0,0,34,221,117,87,250,191,245,117,191,245,94,255,170,255,255,255,254,221,86,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [229,0,5,83,2,220,1,58,12,181,11,63,12,36,17,84,2,72,6,77,2,0,0,72,199,17,143,17,254,34,63,241,17,196,99,255,17,17,227,254,34,35,255,255,255,248,198,56,140,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [229,0,5,78,2,222,1,87,2,73,6,54,12,190,11,56,12,24,17,78,2,0,0,34,221,110,175,245,127,234,235,127,234,189,255,85,255,255,255,253,182,173,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [229,0,5,90,2,219,1,58,12,186,11,94,2,64,6,58,12,24,17,105,2,0,0,68,206,76,204,159,228,159,249,39,38,127,228,147,207,249,36,255,255,255,254,102,76,153,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [229,0,5,93,2,219,1,95,2,63,6,63,12,190,11,54,12,30,17,100,2,0,0,34,221,109,87,250,191,245,111,127,234,189,255,85,255,255,255,253,181,85,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [229,0,5,78,2,219,1,90,2,74,6,60,12,185,11,61,12,31,17,98,2,0,0,34,221,107,175,245,127,234,222,255,213,123,254,171,255,255,255,251,94,172,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [229,0,5,78,2,215,1,97,2,71,6,60,12,188,11,59,12,3,17,102,2,0,0,34,221,107,87,250,191,245,111,127,234,189,255,85,255,255,255,253,174,171,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [229,0,5,94,2,220,1,97,2,63,6,64,12,193,11,54,12,25,17,100,2,0,0,34,221,106,215,250,191,245,111,127,234,189,255,85,255,255,255,253,173,171,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,79,12,196,11,49,12,27,17,77,2,217,1,88,2,89,6,104,2,0,0,162,68,145,18,73,34,36,146,73,17,18,73,36,146,34,36,73,36,73,36,146,68,68,73,34,73,36,146,34,34,73,36,146,73,36,146,73,36,146,73,36,137,17,34,68,68,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,57,12,189,11,56,12,28,17,93,2,200,1,92,2,64,6,99,2,0,0,162,68,145,18,73,17,18,73,36,136,137,36,146,73,17,18,36,146,36,146,73,34,34,36,145,36,146,73,17,17,36,146,73,36,146,73,36,146,73,36,146,68,136,145,17,17,33,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,62,12,184,11,95,2,217,1,96,2,64,6,61,12,30,17,101,2,0,0,137,74,146,169,73,85,84,146,170,170,146,82,170,85,85,73,37,82,170,170,73,42,170,170,170,170,170,170,170,82,74,146,80,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,61,12,188,11,92,2,198,1,57,12,29,17,96,2,61,6,101,2,0,0,145,69,68,85,17,17,85,84,68,85,85,81,17,69,84,85,85,68,68,85,21,85,81,17,21,85,85,85,85,85,85,85,20,68,81,17,20,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,90,2,219,1,94,2,64,6,57,12,186,11,59,12,27,17,107,2,0,0,34,221,119,95,234,255,213,190,255,170,247,253,87,255,255,255,246,171,86,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,94,2,198,1,96,2,61,6,59,12,194,11,52,12,33,17,127,2,0,0,34,221,118,175,245,127,234,223,127,213,123,254,171,255,255,255,251,85,85,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,85,2,220,1,91,2,67,6,54,12,192,11,54,12,28,17,100,2,0,0,34,221,117,175,245,127,234,223,127,213,123,254,171,255,255,255,251,125,88,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,93,2,192,1,94,2,62,6,80,12,202,11,45,12,35,17,103,2,0,0,34,221,117,87,250,191,245,111,191,234,189,255,85,255,255,255,253,189,86,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,93,2,211,1,57,12,192,11,96,2,61,6,55,12,29,17,104,2,0,0,68,206,76,242,127,146,127,228,153,243,254,73,60,255,146,79,255,255,255,230,115,36,194],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,94,2,217,1,95,2,61,6,62,12,193,11,53,12,28,17,97,2,0,0,34,221,110,175,245,127,234,219,191,234,189,255,85,255,255,255,253,186,170,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,81,2,222,1,56,12,188,11,83,2,72,6,60,12,32,17,96,2,0,0,68,206,76,204,159,228,159,249,38,103,63,228,147,207,249,36,255,255,255,254,102,114,73,8],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,94,2,219,1,94,2,60,6,58,12,194,11,52,12,27,17,103,2,0,0,34,221,109,87,250,191,245,109,223,245,94,255,170,255,255,255,254,219,85,66],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,91,2,219,1,92,2,66,6,60,12,189,11,57,12,26,17,96,2,0,0,34,221,107,175,245,127,234,219,191,234,189,255,85,255,255,255,253,181,170,132],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,78,2,219,1,93,2,68,6,63,12,195,11,52,12,32,17,106,2,0,0,34,221,107,87,250,191,245,109,223,245,94,255,170,255,255,255,254,218,170,161,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,94,2,216,1,94,2,59,6,61,12,190,11,56,12,33,17,94,2,0,0,34,221,106,215,250,191,245,109,223,245,94,255,170,255,255,255,254,215,170,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,87,2,222,1,84,2,78,6,86,12,184,11,62,12,28,17,82,2,0,0,34,221,127,127,171,255,85,214,255,170,223,253,87,255,255,255,246,189,168,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,81,2,218,1,88,2,72,6,61,12,188,11,56,12,25,17,96,2,0,0,34,221,125,191,213,255,170,235,127,213,111,254,171,255,255,255,251,93,106,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,88,2,220,1,91,2,69,6,80,12,190,11,56,12,26,17,84,2,0,0,34,221,123,191,213,255,170,235,127,213,111,254,171,255,255,255,251,91,106,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,77,2,220,1,102,2,79,6,63,12,189,11,57,12,252,16,78,2,0,0,34,221,122,223,234,255,213,117,191,234,183,255,85,255,255,255,253,173,90,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,78,2,219,1,55,12,184,11,91,2,80,6,61,12,25,17,81,2,0,0,68,206,78,121,254,73,255,146,78,76,255,146,76,255,228,147,255,255,255,249,146,115,36,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,81,2,221,1,83,2,73,6,82,12,192,11,53,12,30,17,78,2,0,0,34,221,118,223,234,255,213,117,191,234,183,255,85,255,255,255,253,171,90,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,77,2,221,1,87,2,75,6,63,12,193,11,50,12,30,17,98,2,0,0,34,221,117,223,234,255,213,117,191,234,183,255,85,255,255,255,253,170,218,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,78,2,222,1,81,2,77,6,94,12,192,11,53,12,29,17,80,2,0,0,34,221,117,111,245,127,234,186,223,245,91,255,170,255,255,255,254,213,86,161,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,78,2,223,1,59,12,183,11,87,2,87,6,62,12,26,17,76,2,0,0,68,206,76,249,254,73,255,146,78,76,255,146,76,255,228,147,255,255,255,249,159,50,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,93,2,217,1,95,2,66,6,56,12,190,11,54,12,21,17,96,2,0,0,34,221,110,223,234,255,213,117,191,234,183,255,85,255,255,255,253,189,106,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,80,2,196,1,92,2,71,6,87,12,188,11,57,12,29,17,96,2,0,0,34,221,109,223,234,255,213,117,191,234,183,255,85,255,255,255,253,187,106,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,76,2,223,1,82,2,86,6,88,12,194,11,50,12,31,17,98,2,0,0,34,221,109,111,245,127,234,182,223,245,91,255,170,255,255,255,254,221,87,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,78,2,219,1,78,12,187,11,85,2,84,6,57,12,30,17,95,2,0,0,68,206,76,158,127,146,127,228,147,51,63,228,147,63,249,36,255,255,255,254,102,114,112,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,82,2,222,1,52,12,182,11,87,2,70,6,61,12,24,17,96,2,0,0,68,206,76,153,159,228,159,249,36,204,207,249,36,207,254,73,63,255,255,255,153,153,39,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,88,2,222,1,62,12,187,11,88,2,66,6,58,12,25,17,102,2,0,0,68,206,76,147,159,228,159,249,36,204,207,249,36,207,254,73,63,255,255,255,153,147,39,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [229,0,5,56,12,196,11,87,2,220,1,89,2,70,6,50,12,30,17,104,2,0,0,137,74,146,170,165,85,82,74,170,170,73,41,82,85,85,73,37,42,170,170,73,42,170,170,170,170,170,170,170,82,149,37,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [229,0,5,61,12,188,11,77,2,223,1,57,12,31,17,84,2,83,6,98,2,0,0,145,69,68,85,69,21,85,68,69,85,85,17,17,69,68,85,85,68,68,81,85,85,81,17,21,85,85,85,85,85,85,85,20,81,68,69,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [229,0,5,78,2,221,1,62,12,192,11,54,12,26,17,90,2,74,6,95,2,0,0,72,199,17,227,143,241,17,255,136,136,199,17,255,17,17,143,254,34,35,255,255,255,248,198,35,17,194],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [229,0,5,83,2,222,1,86,2,72,6,82,12,191,11,54,12,32,17,102,2,0,0,34,221,122,223,234,255,213,110,191,234,183,255,85,255,255,255,253,181,87,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [229,0,5,92,2,218,1,66,12,161,11,100,2,63,6,84,12,3,17,94,2,0,0,68,206,78,121,254,73,255,146,76,153,63,228,147,63,249,36,255,255,255,254,100,242,100,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [229,0,5,88,2,202,1,96,2,64,6,58,12,192,11,54,12,23,17,96,2,0,0,34,221,118,223,234,255,213,107,95,245,91,255,170,255,255,255,254,215,86,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [229,0,5,95,2,202,1,96,2,60,6,64,12,193,11,52,12,24,17,101,2,0,0,34,221,117,223,234,255,213,107,95,245,91,255,170,255,255,255,254,214,214,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [229,0,5,91,2,216,1,92,2,63,6,54,12,184,11,60,12,22,17,98,2,0,0,34,221,117,111,245,127,234,181,175,250,173,255,213,127,255,255,255,107,85,161,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [229,0,5,93,2,217,1,95,2,63,6,91,12,187,11,58,12,23,17,97,2,0,0,34,221,111,191,213,255,170,214,191,234,183,255,85,255,255,255,253,171,173,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [229,0,5,87,2,218,1,90,2,70,6,86,12,195,11,50,12,24,17,87,2,0,0,34,221,110,223,234,255,213,107,95,245,91,255,170,255,255,255,254,213,171,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [229,0,5,92,2,218,1,97,2,62,6,64,12,191,11,55,12,23,17,105,2,0,0,34,221,109,223,234,255,213,107,95,245,91,255,170,255,255,255,254,213,107,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [229,0,5,91,2,221,1,91,2,63,6,52,12,186,11,59,12,27,17,92,2,0,0,34,221,109,111,245,127,234,181,175,250,173,255,213,127,255,255,255,106,170,208,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [229,0,5,89,2,221,1,89,2,61,6,62,12,188,11,58,12,28,17,88,2,0,0,34,221,107,223,234,255,213,107,95,245,91,255,170,255,255,255,254,223,90,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [229,0,5,90,2,213,1,88,2,64,6,61,12,184,11,61,12,29,17,99,2,0,0,34,221,107,111,245,127,234,181,175,250,173,255,213,127,255,255,255,111,86,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [229,0,5,78,2,216,1,91,2,78,6,83,12,198,11,48,12,23,17,97,2,0,0,34,221,106,239,245,127,234,181,175,250,173,255,213,127,255,255,255,110,214,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [229,0,5,77,2,220,1,66,12,189,11,56,12,32,17,91,2,73,6,96,2,0,0,72,199,17,252,127,31,255,31,140,127,226,34,49,255,196,68,127,255,255,255,24,136,136,199,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [229,0,5,83,2,221,1,54,12,186,11,60,12,6,17,102,2,74,6,97,2,0,0,72,199,17,241,143,227,255,227,227,143,252,68,70,63,248,136,143,255,255,255,227,31,140,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [229,0,5,78,2,222,1,62,12,184,11,60,12,24,17,94,2,78,6,83,2,0,0,72,199,17,227,143,227,255,227,227,143,252,68,70,63,248,136,143,255,255,255,227,30,49,136,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [229,0,5,78,2,215,1,65,12,189,11,57,12,24,17,93,2,83,6,96,2,0,0,72,199,17,226,49,252,127,252,124,113,255,136,136,199,255,17,17,255,255,255,252,99,142,49,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [229,0,5,90,2,216,1,58,12,183,11,64,12,29,17,95,2,67,6,96,2,0,0,72,199,17,199,143,227,255,227,227,143,252,68,70,63,248,136,143,255,255,255,227,28,70,49,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [229,0,5,96,2,220,1,64,12,183,11,60,12,24,17,100,2,62,6,102,2,0,0,72,199,17,198,49,252,127,252,124,113,255,136,136,199,255,17,17,255,255,255,252,99,30,49,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [229,0,5,87,2,219,1,63,12,186,11,91,2,67,6,60,12,28,17,98,2,0,0,68,206,78,78,127,63,254,124,231,254,73,51,255,146,79,255,255,255,230,102,102,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [229,0,5,92,2,219,1,56,12,185,11,61,12,26,17,95,2,62,6,101,2,0,0,72,199,17,196,70,63,143,255,143,142,63,241,17,24,255,226,34,63,255,255,255,140,98,56,196,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [229,0,5,95,2,199,1,59,12,196,11,48,12,27,17,96,2,63,6,100,2,0,0,72,199,17,143,143,227,255,227,227,143,252,68,70,63,248,136,143,255,255,255,227,24,136,198,33,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [229,0,5,90,2,213,1,62,12,185,11,90,2,68,6,59,12,32,17,98,2,0,0,68,206,76,230,127,63,254,124,231,254,73,51,255,146,79,255,255,255,230,79,153,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [229,0,5,94,2,220,1,83,12,184,11,61,12,24,17,97,2,61,6,104,2,0,0,72,199,17,140,113,252,127,252,124,113,255,136,136,199,255,17,17,255,255,255,252,98,56,198,33,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [229,0,5,92,2,222,1,57,12,189,11,56,12,22,17,97,2,65,6,96,2,0,0,72,199,17,140,70,63,143,255,143,142,63,241,17,24,255,226,34,63,255,255,255,140,70,56,196,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [229,0,5,78,2,217,1,62,12,193,11,51,12,26,17,94,2,73,6,98,2,0,0,72,199,17,136,241,252,127,252,124,113,255,136,136,199,255,17,17,255,255,255,252,98,49,24,196,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [229,0,5,78,2,220,1,57,12,187,11,57,12,26,17,90,2,73,6,95,2,0,0,72,199,17,136,198,63,143,255,143,142,63,241,17,24,255,226,34,63,255,255,255,140,68,120,196,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [229,0,5,77,2,220,1,62,12,185,11,57,12,28,17,90,2,77,6,78,2,0,0,72,199,17,136,142,63,143,255,143,142,63,241,17,24,255,226,34,63,255,255,255,140,68,99,24,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,60,12,195,11,47,12,31,17,88,2,224,1,91,2,69,6,98,2,0,0,162,68,145,18,73,36,73,36,145,36,146,73,36,145,36,145,18,68,146,73,36,68,68,137,36,146,73,34,34,36,146,73,36,146,73,36,146,73,36,146,72,145,17,34,68,72,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,57,12,191,11,91,2,199,1,53,12,23,17,93,2,65,6,106,2,0,0,145,69,68,85,69,21,85,21,85,85,81,85,17,81,85,85,17,17,69,85,85,68,68,85,85,85,85,85,85,85,84,81,17,21,17,66],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,63,12,195,11,91,2,217,1,95,2,65,6,49,12,25,17,97,2,0,0,137,74,146,169,82,170,165,85,85,84,170,146,165,85,84,146,82,170,170,164,146,170,170,170,170,170,170,170,165,36,146,146,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,63,12,183,11,86,2,220,1,90,2,66,6,60,12,32,17,100,2,0,0,137,74,146,169,41,85,82,170,170,170,85,73,82,170,170,73,41,85,85,82,73,85,85,85,85,85,85,85,82,149,84,148,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,77,2,218,1,86,12,184,11,93,2,77,6,60,12,25,17,105,2,0,0,68,206,78,121,252,255,249,242,115,254,73,51,255,146,79,255,255,255,230,121,147,8],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,90,2,218,1,60,12,190,11,54,12,24,17,96,2,66,6,103,2,0,0,72,199,17,198,49,252,127,252,124,71,31,241,17,24,255,226,34,63,255,255,255,140,113,196,97,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,90,2,215,1,59,12,192,11,96,2,66,6,52,12,25,17,103,2,0,0,68,206,78,78,127,63,254,124,156,255,146,76,255,228,147,255,255,255,249,156,153,48,128],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,88,2,218,1,56,12,184,11,59,12,34,17,90,2,69,6,108,2,0,0,72,199,17,196,70,63,143,255,143,136,227,254,34,35,31,252,68,71,255,255,255,241,140,120,140,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,87,2,223,1,55,12,186,11,58,12,26,17,92,2,70,6,98,2,0,0,72,199,17,143,143,227,255,227,226,56,255,136,136,199,255,17,17,255,255,255,252,99,24,196,97,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,89,2,215,1,81,12,187,11,55,12,22,17,94,2,67,6,78,2,0,0,72,199,17,142,49,252,127,252,120,248,255,136,136,199,255,17,17,255,255,255,252,99,17,196,68,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,91,2,217,1,61,12,188,11,55,12,25,17,95,2,67,6,103,2,0,0,72,199,17,140,113,252,127,252,120,248,255,136,136,199,255,17,17,255,255,255,252,99,17,24,136,132],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,79,2,222,1,49,12,188,11,56,12,30,17,90,2,75,6,93,2,0,0,72,199,17,140,70,63,143,255,143,31,31,241,17,24,255,226,34,63,255,255,255,140,71,196,68,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,93,2,219,1,61,12,184,11,60,12,25,17,94,2,65,6,97,2,0,0,72,199,17,136,241,252,127,252,120,248,255,136,136,199,255,17,17,255,255,255,252,98,56,196,68,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,90,2,216,1,59,12,193,11,97,2,62,6,50,12,27,17,107,2,0,0,68,206,76,153,159,207,255,158,124,255,146,76,255,228,147,255,255,255,249,147,57,36,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,78,2,221,1,81,12,191,11,52,12,252,16,107,2,77,6,78,2,0,0,72,199,17,136,142,63,143,255,143,31,31,241,17,24,255,226,34,63,255,255,255,140,70,35,17,16,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,78,2,224,1,66,12,195,11,90,2,75,6,53,12,39,17,101,2,0,0,68,206,79,243,243,255,231,146,76,255,146,78,127,228,147,255,255,255,249,158,79,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,90,2,219,1,63,12,186,11,98,2,67,6,62,12,25,17,120,2,0,0,68,206,79,156,252,255,249,228,147,63,228,147,159,249,36,255,255,255,254,103,51,194],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,82,2,223,1,59,12,195,11,90,2,74,6,53,12,36,17,103,2,0,0,68,206,79,60,252,255,249,228,147,63,228,147,159,249,36,255,255,255,254,103,36,240,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,85,2,221,1,61,12,192,11,84,2,70,6,55,12,45,17,103,2,0,0,68,206,79,39,63,63,254,121,36,207,249,36,231,254,73,63,255,255,255,153,156,240,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,79,2,197,1,64,12,200,11,47,12,36,17,92,2,69,6,104,2,0,0,72,199,17,199,199,227,255,227,196,68,99,254,34,35,143,252,68,71,255,255,255,241,140,98,60,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,79,2,221,1,64,12,195,11,96,2,68,6,55,12,31,17,105,2,0,0,68,206,78,103,63,63,254,121,36,207,249,36,231,254,73,63,255,255,255,153,147,60,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,94,2,216,1,60,12,189,11,100,2,63,6,59,12,26,17,103,2,0,0,68,206,78,79,63,63,254,121,36,207,249,36,231,254,73,63,255,255,255,153,146,79,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,94,2,215,1,63,12,191,11,56,12,38,17,94,2,63,6,100,2,0,0,72,199,17,196,71,31,143,255,143,17,17,143,248,136,142,63,241,17,31,255,255,255,198,35,199,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,93,2,218,1,60,12,193,11,56,12,25,17,98,2,63,6,100,2,0,0,72,199,17,143,199,227,255,227,196,68,99,254,34,35,143,252,68,71,255,255,255,241,136,226,60,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,94,2,219,1,79,12,196,11,100,2,62,6,51,12,23,17,97,2,0,0,68,206,76,231,63,63,254,121,36,207,249,36,231,254,73,63,255,255,255,153,51,60,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,87,2,221,1,57,12,191,11,57,12,5,17,103,2,67,6,99,2,0,0,72,199,17,140,120,252,127,252,113,227,31,241,17,28,127,226,34,63,255,255,255,140,70,34,56,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,78,2,219,1,59,12,190,11,56,12,31,17,92,2,79,6,84,2,0,0,72,199,17,140,71,31,143,255,142,60,99,254,34,35,143,252,68,71,255,255,255,241,136,142,56,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,95,2,216,1,65,12,197,11,49,12,31,17,97,2,62,6,107,2,0,0,72,199,17,136,248,252,127,252,113,227,31,241,17,28,127,226,34,63,255,255,255,140,68,98,56,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,95,2,214,1,65,12,186,11,95,2,64,6,61,12,34,17,104,2,0,0,68,206,76,153,207,207,255,156,243,63,228,147,159,249,36,255,255,255,254,100,147,57,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,95,2,216,1,64,12,188,11,95,2,63,6,61,12,23,17,104,2,0,0,68,206,76,147,207,207,255,156,243,63,228,147,159,249,36,255,255,255,254,100,146,78,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [229,0,5,82,2,224,1,57,12,195,11,94,2,74,6,53,12,25,17,94,2,0,0,68,206,79,243,243,255,231,62,79,249,36,231,254,73,63,255,255,255,153,38,78,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [229,0,5,78,2,217,1,87,12,193,11,94,2,71,6,56,12,29,17,100,2,0,0,68,206,79,156,252,255,249,207,147,254,73,57,255,146,79,255,255,255,230,73,51,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [229,0,5,79,2,220,1,65,12,187,11,59,12,29,17,91,2,79,6,78,2,0,0,72,199,17,227,199,227,255,227,143,136,255,136,136,227,255,17,17,255,255,255,252,98,34,34,56,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [229,0,5,78,2,221,1,85,12,189,11,59,12,3,17,106,2,82,6,88,2,0,0,72,199,17,226,56,252,127,252,113,241,31,241,17,28,127,226,34,63,255,255,255,140,124,113,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [229,0,5,89,2,218,1,64,12,190,11,57,12,30,17,95,2,69,6,103,2,0,0,72,199,17,199,199,227,255,227,142,49,31,241,17,28,127,226,34,63,255,255,255,140,120,140,97,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [229,0,5,79,2,222,1,80,12,190,11,95,2,75,6,58,12,28,17,97,2,0,0,68,206,78,103,63,63,254,115,153,63,228,147,159,249,36,255,255,255,254,103,51,48,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [229,0,5,86,2,203,1,62,12,184,11,91,2,69,6,62,12,27,17,98,2,0,0,68,206,78,79,63,63,254,115,153,63,228,147,159,249,36,255,255,255,254,103,36,204,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [229,0,5,89,2,218,1,65,12,186,11,91,2,70,6,64,12,33,17,103,2,0,0,68,206,78,73,207,207,255,156,230,79,249,36,231,254,73,63,255,255,255,153,156,204,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [229,0,5,93,2,217,1,66,12,191,11,57,12,29,17,94,2,64,6,101,2,0,0,72,199,17,143,199,227,255,227,142,49,31,241,17,28,127,226,34,63,255,255,255,140,99,17,140,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [229,0,5,93,2,214,1,68,12,195,11,98,2,62,6,55,12,31,17,100,2,0,0,68,206,76,231,63,63,254,115,153,63,228,147,159,249,36,255,255,255,254,102,76,204,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [229,0,5,90,2,217,1,63,12,185,11,62,12,3,17,103,2,64,6,102,2,0,0,72,199,17,140,120,252,127,252,113,198,35,254,34,35,143,252,68,71,255,255,255,241,140,68,70,48,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [229,0,5,83,2,219,1,64,12,188,11,92,2,73,6,61,12,31,17,102,2,0,0,68,206,76,201,207,207,255,156,230,79,249,36,231,254,73,63,255,255,255,153,60,204,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [229,0,5,79,2,217,1,64,12,192,11,92,2,81,6,56,12,24,17,100,2,0,0,68,206,76,159,63,63,254,115,153,63,228,147,159,249,36,255,255,255,254,100,228,204,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [229,0,5,91,2,214,1,60,12,184,11,104,2,67,6,63,12,1,17,109,2,0,0,68,206,76,153,207,207,255,156,230,79,249,36,231,254,73,63,255,255,255,153,51,51,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [229,0,5,79,2,220,1,65,12,195,11,105,2,75,6,55,12,255,16,81,2,0,0,68,206,76,147,207,207,255,156,206,79,249,36,231,254,73,63,255,255,255,153,50,76,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [229,0,5,85,2,218,1,62,12,186,11,93,2,72,6,62,12,24,17,99,2,0,0,68,206,79,243,243,255,231,51,159,249,36,231,254,73,63,255,255,255,153,50,76,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [229,0,5,92,2,218,1,72,12,189,11,61,12,31,17,93,2,66,6,100,2,0,0,72,199,17,241,199,227,255,227,140,113,255,136,136,227,255,17,17,255,255,255,252,98,35,140,68,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [229,0,5,85,2,219,1,59,12,186,11,62,12,24,17,95,2,73,6,79,2,0,0,72,199,17,227,199,227,255,227,140,113,255,136,136,227,255,17,17,255,255,255,252,98,35,17,136,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [229,0,5,88,2,215,1,67,12,193,11,93,2,70,6,55,12,29,17,95,2,0,0,68,206,79,39,63,63,254,115,57,255,146,78,127,228,147,255,255,255,249,146,76,201,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [229,0,5,91,2,220,1,81,12,186,11,63,12,29,17,92,2,67,6,99,2,0,0,72,199,17,199,199,227,255,227,140,113,255,136,136,227,255,17,17,255,255,255,252,98,34,34,49,16,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [229,0,5,78,2,219,1,57,12,187,11,61,12,30,17,93,2,78,6,78,2,0,0,72,199,17,198,56,252,127,252,113,142,63,241,17,28,127,226,34,63,255,255,255,140,124,98,33,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [229,0,5,89,2,215,1,59,12,187,11,61,12,7,17,102,2,70,6,94,2,0,0,72,199,17,196,120,252,127,252,113,142,63,241,17,28,127,226,34,63,255,255,255,140,120,140,68,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [229,0,5,85,2,219,1,66,12,185,11,62,12,39,17,90,2,70,6,78,2,0,0,72,199,17,196,71,31,143,255,142,49,199,254,34,35,143,252,68,71,255,255,255,241,142,49,136,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [229,0,5,94,2,217,1,61,12,194,11,95,2,66,6,54,12,26,17,101,2,0,0,68,206,76,252,252,255,249,204,153,255,146,78,127,228,147,255,255,255,249,156,146,112,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [229,0,5,92,2,213,1,62,12,191,11,57,12,9,17,102,2,66,6,126,2,0,0,72,199,17,142,56,252,127,252,113,136,199,254,34,35,143,252,68,71,255,255,255,241,140,113,28,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [229,0,5,95,2,217,1,88,12,195,11,95,2,63,6,53,12,36,17,96,2,0,0,68,206,76,207,63,63,254,115,38,127,228,147,159,249,36,255,255,255,254,102,100,156,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [229,0,5,88,2,221,1,60,12,198,11,88,2,70,6,50,12,38,17,104,2,0,0,68,206,76,201,207,207,255,156,201,159,249,36,231,254,73,63,255,255,255,153,147,39,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [229,0,5,88,2,219,1,63,12,192,11,91,2,73,6,55,12,24,17,101,2,0,0,68,206,76,159,63,63,254,115,38,127,228,147,159,249,36,255,255,255,254,102,73,39,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [229,0,5,90,2,217,1,59,12,185,11,62,12,33,17,94,2,68,6,98,2,0,0,72,199,17,136,199,31,143,255,142,49,24,255,196,68,113,255,136,136,255,255,255,254,49,30,35,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [229,0,5,95,2,219,1,62,12,167,11,96,2,63,6,80,12,33,17,105,2,0,0,68,206,76,147,207,207,255,153,146,103,254,73,57,255,146,79,255,255,255,230,76,207,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,95,2,218,1,58,12,185,11,63,12,31,17,96,2,62,6,101,2,0,0,72,199,17,254,63,31,255,28,68,120,255,136,136,227,255,17,17,255,255,255,252,98,56,136,136,132],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,89,2,215,1,58,12,189,11,90,2,69,6,60,12,25,17,92,2,0,0,68,206,79,156,252,255,249,201,60,255,146,78,127,228,147,255,255,255,249,147,50,73,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,86,2,222,1,62,12,193,11,91,2,70,6,55,12,28,17,79,2,0,0,68,206,79,60,252,255,249,201,60,255,146,78,127,228,147,255,255,255,249,147,36,146,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,93,2,218,1,66,12,188,11,94,2,65,6,61,12,26,17,100,2,0,0,68,206,79,39,63,63,254,114,79,63,228,147,159,249,36,255,255,255,254,100,156,146,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,90,2,219,1,60,12,183,11,91,2,67,6,64,12,30,17,79,2,0,0,68,206,78,124,252,255,249,201,60,255,146,78,127,228,147,255,255,255,249,146,100,146,66],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,93,2,221,1,58,12,194,11,101,2,64,6,55,12,3,17,92,2,0,0,68,206,78,103,63,63,254,114,79,63,228,147,159,249,36,255,255,255,254,100,147,36,144,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,93,2,219,1,65,12,184,11,95,2,67,6,63,12,29,17,96,2,0,0,68,206,78,79,63,63,254,114,79,63,228,147,159,249,36,255,255,255,254,100,146,73,36,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,92,2,210,1,62,12,191,11,103,2,66,6,56,12,7,17,103,2,0,0,68,206,78,73,207,207,255,156,146,115,254,73,57,255,146,79,255,255,255,230,121,240,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,92,2,204,1,84,12,193,11,92,2,63,6,55,12,30,17,101,2,0,0,68,206,76,252,252,255,249,201,39,63,228,147,159,249,36,255,255,255,254,103,63,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,78,2,218,1,65,12,187,11,91,2,82,6,62,12,25,17,106,2,0,0,68,206,76,231,63,63,254,114,73,207,249,36,231,254,73,63,255,255,255,153,201,240,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,95,2,218,1,63,12,187,11,61,12,33,17,93,2,61,6,105,2,0,0,72,199,17,140,120,252,127,252,113,17,28,127,196,68,113,255,136,136,255,255,255,254,49,143,225,0],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,90,2,219,1,58,12,185,11,92,2,66,6,63,12,25,17,101,2,0,0,68,206,76,201,207,207,255,156,146,115,254,73,57,255,146,79,255,255,255,230,102,124,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,78,2,223,1,62,12,195,11,53,12,27,17,91,2,82,6,107,2,0,0,72,199,17,136,248,252,127,252,113,17,28,127,196,68,113,255,136,136,255,255,255,254,49,136,252,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,91,2,220,1,62,12,189,11,92,2,65,6,59,12,27,17,95,2,0,0,68,206,76,153,207,207,255,156,146,115,254,73,57,255,146,79,255,255,255,230,100,159,8],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,86,2,222,1,66,12,189,11,87,2,69,6,60,12,33,17,97,2,0,0,68,206,76,147,207,207,255,156,146,115,254,73,57,255,146,79,255,255,255,230,79,240,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [229,0,5,90,2,223,1,59,12,193,11,56,12,35,17,91,2,67,6,78,2,0,0,72,199,17,143,199,227,255,227,196,99,31,241,17,31,255,17,17,255,255,255,252,99,24,196,68,32],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [229,0,5,91,2,224,1,86,12,185,11,91,2,65,6,60,12,24,17,78,2,0,0,68,206,76,252,252,255,249,228,228,255,146,79,255,146,79,255,255,255,230,121,146,66],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [229,0,5,79,2,221,1,64,12,193,11,86,2,78,6,54,12,27,17,80,2,0,0,68,206,76,252,252,255,249,228,231,254,73,63,254,73,63,255,255,255,153,36,153,36,32],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [229,0,5,77,2,222,1,59,12,192,11,89,2,80,6,56,12,28,17,98,2,0,0,68,206,76,252,252,255,249,228,156,255,146,79,255,146,79,255,255,255,230,73,147,194],
    },
    ]
};

export default HAIER_YR_HD06
